import SignInForm from "./sign-in-form";

import "./auth-forms.scss";


const Forms = {
    SignIn : SignInForm,
}

export default Forms;